import { IconProps } from "ztypes/icon-props";

const IconMinus: React.FunctionComponent<IconProps> = (props) => {
  return (
    <svg
      onClick={props.onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect
        x="0.75"
        y="0.75"
        width="22.5"
        height="22.5"
        rx="11.25"
        stroke="#3D3D3D"
        strokeOpacity="0.6"
        strokeWidth="1.5"
      />
      <rect x="6" y="11.25" width="12" height="1.5" fill="#3D3D3D" />
    </svg>
  );
};

export default IconMinus;
